import { render, staticRenderFns } from "./row-element.vue?vue&type=template&id=617c2037&"
import script from "./row-element.vue?vue&type=script&lang=ts&"
export * from "./row-element.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('617c2037')) {
      api.createRecord('617c2037', component.options)
    } else {
      api.reload('617c2037', component.options)
    }
    module.hot.accept("./row-element.vue?vue&type=template&id=617c2037&", function () {
      api.rerender('617c2037', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/row-element.vue"
export default component.exports